import React from 'react';
import { stats } from '../data/content';
export function StatsBar() {
  return <section className="w-full border-y border-stone-200 bg-white py-10 sm:py-14" data-id="element-158" data-mp="1tarjq9bipqkw">
      <dl className="mx-auto grid max-w-6xl grid-cols-2 gap-y-8 px-5 md:grid-cols-4 md:gap-y-0" data-id="element-159" data-mp="1t8nkw5sh7hrh">
        {stats.map((stat, index) => <div key={stat.label} className={`px-4 text-center ${index > 0 ? 'md:border-l md:border-stone-200' : ''}`} data-id="element-160" data-mp="1jd3mncqfw6zk" data-mpi={index}>
            <dt className="sr-only" data-id="element-161" data-mp="19mr3noy9wlvj">{stat.label}</dt>
            <dd data-id="element-162" data-mp="19l7oy2s9mivv">
              <span className="block text-3xl font-bold tracking-tight text-stone-900 sm:text-4xl" data-id="element-163" data-mp="19ko68jusjqgs">
                {stat.value}
              </span>
              <span className="mt-1 block text-[10px] font-semibold uppercase tracking-[0.16em] text-stone-500 sm:text-xs" data-id="element-164" data-mp="10mvqxfp2kite">
                {stat.label}
              </span>
            </dd>
          </div>)}
      </dl>
    </section>;
}